import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row mb-2-half mb-lg-3-half" }
const _hoisted_3 = { class: "col-12 mb-half mb-lg-0" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = {
  class: "col-lg-4 col-xl-3 collapse",
  id: "collapseProductsFilter"
}
const _hoisted_7 = { class: "product-filter mb-2 mb-lg-0" }
const _hoisted_8 = { class: "d-flex justify-content-between pb-quarter" }
const _hoisted_9 = { class: "display-4 mb-0 me-1" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", { class: "mb-0" }, null, -1)
const _hoisted_11 = { class: "product-filter-bottom" }
const _hoisted_12 = {
  class: "col-lg-8 col-xl-9",
  ref: "listElement"
}
const _hoisted_13 = { class: "d-block" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_15 = { class: "d-flex justify-content-center" }
const _hoisted_16 = {
  class: "spinner-border text-primary mb-1",
  role: "status"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading", -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = {
  key: 1,
  class: "text-center"
}
const _hoisted_21 = {
  class: "spinner-border spinner-border-sm",
  role: "status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "search", {
          search: _ctx.list.search
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "btn btn-primary d-lg-none justify-content-center w-100",
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleTextBtn = !_ctx.toggleTextBtn)),
          "data-bs-toggle": "collapse",
          "data-bs-target": "#collapseProductsFilter",
          "aria-expanded": "false",
          "aria-controls": "collapseProductsFilter"
        }, _toDisplayString(_ctx.toggleTextBtn ? 'hide filter' : 'show filter'), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.$t('filter_by')), 1),
            (!_ctx.list.filter.isPropertyEqualToInitialState('categories'))
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: "#",
                  role: "button",
                  class: "link-underline",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.list.filter.resetFilter()), ["prevent"]))
                }, _toDisplayString(_ctx.$t('reset_all')), 1))
              : _createCommentVNode("", true)
          ]),
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _renderSlot(_ctx.$slots, "filter", {
              filter: _ctx.list.filter,
              categories: _ctx.categories
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.list.isFetchingItems.value ? _ctx.$t('loading') : _ctx.$tc('shown_products', _ctx.list.filteredItems.value.length, {count: _ctx.list.filteredItems.value.length})), 1),
        _hoisted_14,
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_15, [
              _withDirectives(_createElementVNode("div", _hoisted_16, _hoisted_18, 512), [
                [_vShow, _ctx.list.isLoading.value]
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_TransitionGroup, {
          name: _ctx.view === 'thumbs' ? 'fade' : 'order',
          tag: "div",
          class: "row position-relative"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list.visibleItems.value, (item, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: item.uid
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass([
                                    'transition-group-item',
                                    {
                                        'col-sm-6 col-xl-4 mb-1': _ctx.view === 'thumbs',
                                        'col-12 mb-half product-products-list': _ctx.view === 'list',
                                    }
                                 ]),
                  innerHTML: item.content
                }, null, 10, _hoisted_19),
                (_ctx.showTeaser && index + 1 === 6)
                  ? _renderSlot(_ctx.$slots, "teaser", { key: 0 })
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ]),
          _: 3
        }, 8, ["name"]),
        (_ctx.list.pagination.type.value === 'pagination')
          ? (_openBlock(), _createBlock(_component_el_pagination, {
              key: 0,
              "current-page": _ctx.list.pagination.currentPage.value,
              "onUpdate:currentPage": _ctx.handlePaginationClick,
              "hide-on-single-page": "",
              layout: "prev, pager, next",
              "pager-count": 5,
              "page-size": _ctx.list.pagination.itemsPerPage.value,
              total: _ctx.list.pagination.totalItems.value
            }, null, 8, ["current-page", "onUpdate:currentPage", "page-size", "total"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_20, [
              (!_ctx.list.pagination.isLastPage.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: _normalizeClass(['btn btn-primary btn-loading', { 'loading': _ctx.list.isLoading.value }]),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.list.pagination.nextPage()))
                  }, [
                    _createVNode(_Transition, { name: "fade" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("span", _hoisted_21, null, 512), [
                          [_vShow, _ctx.list.isLoading.value]
                        ])
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("load_more")), 1)
                  ], 2))
                : _createCommentVNode("", true)
            ]))
      ], 512)
    ])
  ]))
}